export default [{
    path: 'project',
    component: () => import('@/views/organization/project/project.main'),
    children: [{
        path: 'list',
        components: {
            list: () => import('@/views/organization/project/project.list'),
        },
    }, {
        path: 'detail',
        components: {
            detail: () => import('@/views/organization/project/project.detail'),
        },
    }]
}]